import { useState } from 'react';
import { Upload, Spin, Image } from 'antd';
import get from 'lodash/get';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { IMAGE_UPLOAD, CONTACTUS_IMAGE_UPLOAD } from '../../constants/apiEndpoints';

const SingleImageUpload = (props) => {
  const { imageUrl, onUploadDone, setUserImage } = props;

  const [loading, setLoading] = useState(false);
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );
  const handleChange = (info) => {
    if (get(info, 'file.status') === 'uploading') {
      setLoading(true);
      return;
    }
    if (get(info, 'file.status') === 'done') {
      get(info, 'file.response');
      setLoading(false);
      onUploadDone(get(info, 'file.response.data'));
    } else {
      setLoading(false);
    }
  };
  const handleRemove = () => {
    setUserImage(null);
  };
  return (
    <Spin spinning={loading}>
      {imageUrl ? (
        <div style={{ position: 'relative', width: 150, height: 150, borderRadius: "100%", overflow: "hidden" }}>
          <Image src={imageUrl} alt="Preview" width={150} height={150} />
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              cursor: 'pointer',
              background: '#fff',
              padding: '4px',
            }}
            onClick={handleRemove}
          >
            Remove
          </div>
        </div>
      ) : (
        <Upload
          name="file"
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          // accept="image/*"
          accept=".png,.jpeg,.jpg"
          action={CONTACTUS_IMAGE_UPLOAD}
          beforeUpload={() => { }}
          onChange={handleChange}
        >
          {imageUrl ? (
            <img src={imageUrl} alt="avatar" style={{ width: '100%' }} />
          ) : (
            uploadButton
          )}
        </Upload>
      )}
    </Spin>
  );
};

export default SingleImageUpload;
